import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import { PushService } from '../../providers/push/push.service';
import { ThemeService } from '../../providers/theme/theme.service';

@Component({
	selector: 'app-tutorial',
	templateUrl: './tutorial.page.html',
	styleUrls: ['./tutorial.page.scss'],
})
export class TutorialPage implements AfterViewInit {
	@ViewChild(IonSlides) slides: IonSlides;

	public slideData = [
		{
			title: 'Welcome to PonyPlace',
			description: 'The simplest horse marketplace.',
			buttonText: 'Continue',
		},
		{
			title: "Buyer's Choice",
			description: 'Use filters to find the perfect pony.',
			buttonText: 'Continue',
		},
		{
			title: "Seller's Paradise",
			description: 'Chat with buyers in realtime.',
			buttonText: "Let's go!",
		},
	];

	isDarkMode = false;
	isSliding = false;
	hasPushPermission = false;
	isRequestingPush = false;

	constructor(
		private modalController: ModalController,
		private pushService: PushService,
		private themeService: ThemeService
	) {
		this.isDarkMode = this.themeService.isDarkMode;
	}

	ngAfterViewInit(): void {
		this.slides.ionSlideWillChange.subscribe(() => {
			this.isSliding = true;
		});
		this.slides.ionSlideDidChange.subscribe(() => {
			this.isSliding = false;
		});
	}

	async requestPush(event?: Event): Promise<void> {
		event?.stopPropagation();
		if (this.isRequestingPush) {
			return;
		}

		this.isRequestingPush = true;
		try {
			this.hasPushPermission = await this.pushService.requestPushPermission();
		} finally {
			this.isRequestingPush = false;
		}
	}

	goToSlide(event: Event, index: number): void {
		event.stopPropagation();
		if (this.isSliding) {
			return;
		}
		this.slides.slideTo(index);
		if (index === this.slideData.length) {
			this.modalController.dismiss();
		}
	}

	skipTutorial(): void {
		this.modalController.dismiss();
	}
}
